const ParentItemWithChildrenQuery = /* GraphQL */ `
  query ParentItemWithChildrenQuery($path: String!, $language: String = "en") {
    item(path: $path, language: $language) {
      parent {
        ...basicInfo
        children(hasLayout: true, first: 15) {
          results {
            ...basicInfo
          }
        }
      }
    }
  }
  fragment basicInfo on Item {
    title: field(name: "title") {
      jsonValue
    }
    hideFromParentChildNavigation: field(name: "hideFromParentChildNavigation") {
      value
    }
    url {
      url
      path
    }
  }
`;
export default ParentItemWithChildrenQuery;
